import { KOGMediaQuery } from "@/main/services/utilsLayout";
import styled, { css } from "styled-components";

export const Container = styled.div`
	padding: 0 0 2rem;

	> h2 {
		font-weight: bold;
	}

	.MuiRadio-colorSecondary.Mui-checked {
		color: ${({ theme }) => theme.pantone2726C};
	}
`;

export const FooterButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	gap: 1rem;

	> button {
		max-width: 200px;
	}
`;

// Components to insides Sections
export const HeaderSection = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 1rem;
`;

export const HeaderText = styled.h4`
	color: #000;
	font-size: 1rem;
	font-weight: bold;
	margin: 0;
`;

export const ContainerSection = styled.div`
	background-color: #ecf1f6;
	padding: 1rem;
	border-radius: 6px;
	margin: 0 0 2rem 0;
`;

export const ActionButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
`;

export const ContainerTitle = styled.div`
	display: flex;
	flex-direction: row;
	align-items: baseline;
	gap: 1rem;

	${({ theme }) =>
		KOGMediaQuery({
			breakpoint: theme.breakpoints.mobile,
			styles: css`
				flex-wrap: wrap;
			`,
		})}
`;

export const ContainerBoxGrid = styled.div`
	@media (max-width: 750px) {
		table {
			min-width: 750px;
		}
	}

	max-height: 320px;
	overflow-y: auto;
	overflow-x: hidden;
	overflow: auto;
	margin: 0.4rem 0 0 0;
`;
